import { render, staticRenderFns } from "./NoMessage.vue?vue&type=template&id=3294bffc&scoped=true"
import script from "./NoMessage.vue?vue&type=script&lang=js"
export * from "./NoMessage.vue?vue&type=script&lang=js"
import style0 from "./NoMessage.vue?vue&type=style&index=0&id=3294bffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294bffc",
  null
  
)

export default component.exports